import { 
	Chat16,
} from '@carbon/icons';


export default [
	/* **** */
	{
		path: '/chat',
		layout: 'Admin',
		component: 'Chat',
		meta: {
			name: 'Чат',
			icon: Chat16,
			binding: 'chat_messages',
		},
		menu: true,
		permissions: [ 'chat_message_view' ],
	},
	/* **** */
	{
		path: '/chat/:id',
		layout: 'Admin',
		component: 'Chat',
		meta: {
			name: 'Чат',
			icon: Chat16,
		},
		menu: false,
		permissions: [ 'chat_message_view' ],
	},
	/* **** */
];
